import { ZfTooltip } from '@zafire/react';
import type { CSSProperties, FunctionComponent } from 'react';
import { useEffect, useRef, useState } from 'react';

interface IProps {
    text: string;
    width: number;
    padding?: number;
    styles?: CSSProperties;
}

export const OverflowTooltip: FunctionComponent<IProps> = ({ text, width, padding, styles }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const check = () => setIsOverflowing(el.scrollWidth > el.clientWidth);
        const id = requestAnimationFrame(check);

        const observer = new ResizeObserver(check);
        observer.observe(el);

        return () => {
            cancelAnimationFrame(id);
            observer.disconnect();
        };
    }, [text, ref.current?.clientWidth]);

    const content = (
        <span
            ref={ref}
            style={{
                display: 'block',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                width: `calc(${width}px - ${padding || 0}px)`,
                ...styles,
            }}
        >
            {text}
        </span>
    );

    if (isOverflowing)
        return (
            <ZfTooltip text={text} alignment="start" contentAlignment="start">
                <div slot="anchor">{content}</div>
            </ZfTooltip>
        );

    return content;
};
